import { defineStore } from 'pinia';
import { ref } from 'vue';

export interface PermissionCheck {
    action: string;
    resource: string;
    result: boolean;
}

export const useDevStore = defineStore('dev', () => {
    const fastLogout = ref(false);
    const permissionChecks = ref(new Map<string, PermissionCheck>());

    function trackPermissionCheck(
        action: string,
        resource: string,
        result: boolean
    ) {
        const key = `${action}:${resource}`;
        permissionChecks.value.set(key, { action, resource, result });
    }

    function clearPermissionChecks() {
        permissionChecks.value = new Map();
    }

    return {
        fastLogout,
        permissionChecks,
        trackPermissionCheck,
        clearPermissionChecks,
    };
});
